module.exports = __webpack_public_path__ + "KlavikaBold.4b79521c3ddeaabf815d.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/fonts/klavika_font/KlavikaBold.ttf
// module id = ../../../../../src/assets/fonts/klavika_font/KlavikaBold.ttf
// module chunks = styles